<template>
  <section id="protect" class="section">
    <div class="section__content">
      <div class="secure-text" data-aos="fade-up">
        <p>【中國信託投信獨立經營管理】</p>
        <span class="highlight"
          >本基金經金管會核准或同意生效。惟不表示絕無風險，基金經理公司以往之經理績效不保證基金之最低投資收益；基金經理公司除盡善良管理人之注意義務外，不負責本基金之盈虧，亦不保證最低之收益，投資人申購前應詳閱基金公開說明書。</span
        >本資料僅供參考，請勿將其視為買賣基金或其他任何投資之建議或邀約。以上所作任何投資意見與市場分析結果，係依據資料製作當時情況進行判斷，本公司已力求資訊之正確與完整，惟文中之數據、預測或意見仍可能有脫漏或錯誤之處，本公司不保證本資料內容及來源資料之正確及完整性。匯率走勢亦可能影響所投資之海外資產而使資產價值變動；本文提及之經濟走勢預測不必然代表基金之績效，或因市場環境變化已有變更，投資標的之價格與收益亦將隨時變動，<span
          class="highlight"
          >投資人因不同時間進場，將有不同之投資績效，過去的績效亦不代表未來績效之保證，投資人應自行判斷投資標的、投資風險，或尋求專業之投資建議，不應將本資料內容引為投資之唯一依據</span
        >，若有投資損益或因使用本資料所生之直接或間接損失，應由投資人自行負責。本公司或關係企業與其任何董事、受僱人不因此而承擔任何損害賠償責任。
        有關基金應負擔之費用（境外基金含分銷費用）已揭露於基金之公開說明書(或中譯本)或投
        資人須知中，投資人可至公開資訊觀測站或境外基金資訊觀測站中查詢。各銷售機構備有基金公開說明書及投資人須知，歡迎索取。<span
          class="highlight"
          >投資人應注意基金投資之風險包括利率風險、債券交易市場流動性不足之風險及投資無擔保公司債之風險；或有因利率變動、債券交易市場流動性不足及定期存單提前解約而影響基金淨值下跌之風險，同時或有受益人大量贖回時，致延遲給付贖回價款之可能。</span
        >本文提及之經濟走勢預測不必然代表本基金之績效，本基金投資風險請詳閱基金公開說明書。<span
          class="highlight"
          >投資涉及新興市場部份，其波動性與風險程度可能較高，且其政治與經濟情勢穩定度可能低於已開發國家，也可能使資產價值受不同程度之影響。投資人申購本基金係持有基金受益憑證，而非本文提及之投資資產或標的。本公司總代理之法盛國際系列基金CT級別部分，手續費雖可遞延收取，惟每年仍需支付1%分銷費，可能造成實際負擔費用增加。CT級別於投資人持有滿3年後自動轉換為R級別，無需再支付分銷費。基金配息率不代表基金報酬率，且過去配息率不代表未來配息率</span
        >；基金淨值可能因市場因素而上下波動。投資人申購前應詳閱基金公開說明書。<span
          class="highlight"
          >基金投資風險請詳閱基金公開說明書。詳細資訊請參考各基金之公開說明書與投資人須知。</span
        >
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'Protect',
  props: {},
  data: () => {
    return {};
  },
  computed: {
    // ...mapState([])
  },
  methods: {
    // ...mapActions([]),
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
$assets: '~@/assets/images/protect/';

#protect {
  .section__content {
    .secure-text {
      width: 1300px;
      font-size: 19px;
      line-height: lineHeight(19, 38);
      padding: 12px 0 70px 0;
      color: #3f3f3f;
      @include tabletX {
        width: vwX(1300);
        padding: vwX(12) 0 vwX(70) 0;
      }
      @include tablet {
        width: vwM(944);
        font-size: vwM(25);
        line-height: lineHeight(25, 53);
        padding: vwM(36) 0 vwM(112) 0;
      }
      .highlight {
        color: #009eb5;
      }
    }
  }
}
</style>
